import { useCallback } from 'react';

import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { AgentDelegationKind, AgentDelegationTarget } from '@this+that/models';
import log from 'loglevel';

const GET_AGENT_DELEGATION_TARGETS = gql`
  query getAgentDelegationTargets($kinds: [AgentDelegationKind!]) {
    getAgentDelegationTargets(kinds: $kinds) {
      id
      kind
      name
      subtitle
      availability
      activeTaskCount
      availableLocalRuntimes
      availableAgentProfiles {
        name
        description
      }
    }
  }
`;

interface GetAgentDelegationTargetsData {
  getAgentDelegationTargets: AgentDelegationTarget[];
}

export function useGetAgentDelegationTargets() {
  const client = useApolloClient();

  const getAgentDelegationTargets = useCallback(
    async (kinds?: AgentDelegationKind[]): Promise<AgentDelegationTarget[]> => {
      try {
        const { data } = await client.query<GetAgentDelegationTargetsData>({
          query: GET_AGENT_DELEGATION_TARGETS,
          variables: { kinds },
          fetchPolicy: 'network-only',
        });
        return data?.getAgentDelegationTargets ?? [];
      } catch (fetchError) {
        log.error(
          'useGetAgentDelegationTargets: failed to fetch delegation targets',
          fetchError,
        );
        throw fetchError;
      }
    },
    [client],
  );

  return { getAgentDelegationTargets };
}
